import React, { useEffect } from 'react';
import { Button, Form, Input, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {
	hideMessage,
	showAuthLoader,
	userSignIn,
} from '../appRedux/actions/Auth';
import CircularProgress from '../components/CircularProgress/index';

const FormItem = Form.Item;

const SignIn = (props) => {
	const dispatch = useDispatch();
	const { loader, alertMessage, showMessage, authUser } = useSelector(
		({ auth }) => auth
	);
	const history = useHistory();

	useEffect(() => {
		if (showMessage) {
			setTimeout(() => {
				dispatch(hideMessage());
			}, 100);
		}
		if (authUser !== null) {
			history.push('/');
		}
	});

	const handleSubmit = (e) => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				dispatch(showAuthLoader());
				dispatch(userSignIn(values));
			}
		});
	};

	const { getFieldDecorator } = props.form;

	return (
		<div className="gx-app-login-wrap">
			<div className="gx-app-login-container">
				<div className="gx-app-login-main-content">
					<div className="gx-app-logo-content">
						<div className="gx-app-logo-content-bg">
							<img
								src={require('../assets/images/singup-bg.jpg')}
								alt="Neature"
							/>
						</div>
						<div className="gx-app-logo-wid">
							<h1>
								Sign In
							</h1>
						</div>
						<div className="gx-app-logo">
							<img alt="example" src={require('../assets/images/logo.png')} />
						</div>
					</div>
					<div className="gx-app-login-content">
						<Form
							onSubmit={handleSubmit}
							className="gx-signin-form gx-form-row0"
						>
							<FormItem>
								{getFieldDecorator('email', {
									initialValue: '',
									rules: [
										{
											required: false,
											type: 'email',
											message: 'The input is not valid E-mail!',
										},
									],
								})(<Input placeholder="Email" />)}
							</FormItem>
							<FormItem>
								{getFieldDecorator('password', {
									initialValue: '',
									rules: [
										{ required: false, message: 'Please input your Password!' },
									],
								})(<Input type="password" placeholder="Password" />)}
								<Link className="forgot-link" to="/forgot-password">
									Forgot Password
								</Link>
							</FormItem>

							<FormItem>
								<Button type="primary" className="gx-mb-0" htmlType="submit">
								Sign In
								</Button>
							</FormItem>

							<span className="gx-text-light gx-fs-sm"></span>
						</Form>
					</div>

					{loader ? (
						<div className="gx-loader-view">
							<CircularProgress />
						</div>
					) : null}
					{showMessage ? message.error(alertMessage.toString()) : null}
				</div>
			</div>
		</div>
	);
};

const WrappedNormalLoginForm = Form.create()(SignIn);

export default WrappedNormalLoginForm;
